<template>
  <div class="card card-absolute rfo-card rfo-card--primary oa-section-card">
    <div class="card-header bg-primary text-white">
      <h5 class="mb-0"><i class="fa fa-search me-2"></i>Find The Order</h5>
    </div>
    <div class="card-body">
      <div class="alert alert-light mb-3">
        <i class="fa fa-info-circle font-primary me-2"></i>
        Enter the order UUID to find its current Odoo queue message and payment state.
      </div>
      <label class="form-label fw-bold">Order UUID <span class="text-danger">*</span></label>
      <div class="input-group">
        <input
          v-model="localUuid"
          type="text"
          class="form-control border border-primary font-monospace"
          placeholder="e.g. 2effa87e-dcb1-4bef-9539-b5e97f16feff"
          :disabled="isLooking"
          @keyup.enter="onLookup"
        />
        <button
          class="btn btn-primary text-white"
          :disabled="!isUuidValid || isLooking"
          @click="onLookup"
        >
          <span v-if="isLooking">
            <span class="spinner-border spinner-border-sm me-1"></span>Looking up…
          </span>
          <span v-else><i class="fa fa-search me-1"></i>Lookup</span>
        </button>
      </div>
      <div v-if="localUuid && !isUuidValid" class="form-text text-danger">
        <i class="fa fa-exclamation-triangle me-1"></i>This doesn't look like a valid order ID.
      </div>
      <div v-else class="form-text">
        <i class="fa fa-info-circle me-1"></i>We'll look the order up in Odoo. If Odoo doesn't have
        an invoice ready for it yet, you'll be able to ask for one in the next step.
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  uuid: { type: String, default: '' },
  isLooking: { type: Boolean, default: false },
});

const emit = defineEmits(['lookup']);

const localUuid = ref(props.uuid);

watch(
  () => props.uuid,
  (val) => {
    localUuid.value = val;
  },
);

const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const isUuidValid = computed(() => UUID_V4_REGEX.test(localUuid.value.trim()));

function onLookup() {
  if (!isUuidValid.value) return;
  emit('lookup', localUuid.value.trim());
}
</script>
